module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors/img_main-ce72236fd5ceae107b5baf9cb299173c.jpg";